import React from "react";

function Display({ rules }) {
  return <div>{rules}</div>;
}
export default Display;
